export const dadosIniciais = {
  id_consulta: 0,
  idPaciente: 0,
  idVinculo: 0,
  nu_consulta: 0,
  ventilacaoNaoInvasivaBIPAP: "",
  bipapDataInicio: "",
  bipapDuracao: "",
  traquestomia: "",
  traqueostomiaDataInicio: "",
  traqueostomiaProcedimento: "",
  gastrostomia: "",
  gastrostomiaDataInicio: "",
  sondaNasogastrica: "",
  sondaNasogastricaDataInicio: "",
  coughAssist: "",
  tecnologiaComunicacao: "",
  assistenciaDomiciliar: "",
  multidisciplinar: "",
  multidisciplinarTipo: [],
  usoCadeiraDeRodas: "",
  tipoProcedimento: "",
  frequenciaCardiaca: "",
  pressaoArterial: "",
  pesoAtual: "000000",
  perdaDePeso: "",
  fluenciaVerbal: "",
  rastreioComportamental: "",
  apatia: "",
  statusCognitivo: "",
  reflexoFotomotor: "",
  papilederma: "",
  motricidadeOcular: "",
  ptosePalpebral: "",
  reflexoNauseoso: "",
  musculaturaFacial: [],
  masseter: "",
  linguaMovimentacao: "",
  linguaAtrofia: "",
  linguaFasciculacao: "",
  veloPalatino: "",
  disartria: "",
  anartria: "",
  abducaoCoxasDireita: "",
  abducaoCoxasEsquerda: "",
  flexaoQuadrisDireita: "",
  flexaoQuadrisEsquerda: "",
  extensaoJoelhosDireita: "",
  extensaoJoelhosEsquerda: "",
  flexaoJoelhosDireita: "",
  flexaoJoelhosEsquerda: "",
  dorsiflexaoJoelhosDireita: "",
  dorsiflexaoJoelhosEsquerda: "",
  inversaoPesDireita: "",
  inversaoPesEsquerda: "",
  flexaoPlanarPesDireita: "",
  flexaoPlanarPesEsquerda: "",
  abducaoOmbrosDireita: "",
  abducaoOmbrosEsquerda: "",
  flexaoCotovelosDireita: "",
  flexaoCotovelosEsquerda: "",
  extensaoCotovelosDireita: "",
  extensaoCotovelosEsquerda: "",
  flexaoPunhosDireita: "",
  flexaoPunhosEsquerda: "",
  extensaoDedosDireita: "",
  extensaoDedosEsquerda: "",
  abducaoDedosDireita: "",
  abducaoDedosEsquerda: "",
  abducaoPolegarDireita: "",
  abducaoPolegarEsquerda: "",
  primeiroInterosseoDorsalDireita: "",
  primeiroInterosseoDorsalEsquerda: "",
  MIDProximal: "",
  MIDDistal: "",
  MIEProximal: "",
  MIEDistal: "",
  MSDProximal: "",
  MSDDistal: "",
  MSEProximal: "",
  MSEDistal: "",
  fasciculacoesMotor: "",
  fasciculacoesMotorOnde: [],
  MSD: "",
  MSE: "",
  MID: "",
  MIE: "",
  reflexoBicipitalDireita: "",
  reflexoBicipitalEsquerda: "",
  reflexoTricipitalDireita: "",
  reflexoTricipitalEsquerda: "",
  reflexoPatelarDireita: "",
  reflexoPatelarEsquerda: "",
  reflexoAquileuDireita: "",
  reflexoAquileuEsquerda: "",
  reflexoPeitoralDireita: "",
  reflexoPeitoralEsquerda: "",
  reflexoCutaneoDireita: "",
  reflexoCutaneoEsquerda: "",
  sinalDeHoffmannDireita: "",
  sinalDeHoffmannEsquerda: "",
  tremor: "",
  bradicinesia: "",
  ataxia: "",
  parestesias: "",
  disestesias: "",
  alodinia: "",
  MIDProximalVibratoria: "",
  MIDProximalCinetPost: "",
  MIDProximalTactil: "",
  MIDProximalDor: "",
  MIDDistalVibratoria: "",
  MIDDistalCinetPost: "",
  MIDDistalTactil: "",
  MIDDistalDor: "",
  MIEProximalVibratoria: "",
  MIEProximalCinetPost: "",
  MIEProximalTactil: "",
  MIEProximalDor: "",
  MIEDistalVibratoria: "",
  MIEDistalCinetPost: "",
  MIEDistalTactil: "",
  MIEDistalDor: "",
  MSDProximalVibratoria: "",
  MSDProximalCinetPost: "",
  MSDProximalTactil: "",
  MSDProximalDor: "",
  MSDDistalVibratoria: "",
  MSDDistalCinetPost: "",
  MSDDistalTactil: "",
  MSDDistalDor: "",
  MSEProximalVibratoria: "",
  MSEProximalCinetPost: "",
  MSEProximalTactil: "",
  MSEProximalDor: "",
  MSEDistalVibratoria: "",
  MSEDistalCinetPost: "",
  MSEDistalTactil: "",
  MSEDistalDor: "",
  disfuncaoAutonomica: "",
  tipoDisfuncao: [],
  disfuncaoAutonomicaOutra: "",
  examesPredefinidos: "",
  diagnosticoEhELA: "",
  dataDiagnosticoELA: "",
  classificacaoKingsCollege: "",
  escalaFuncional: "",
  velocidadeDeProgressao: "",
  causaELA: "",
  localDeInicio: "",
  fenotipoDeInicio: "",
  observacaoELA: "",
  sugestaoDiagnostico: "",
  examesPredefinidosSelect: "",

  examesPredefinidosExamesEProcedimentos: [],
  outrosExamesLaboratoriais: [],
  examesLaboratoriaisObservacao: "",

  // outros exames
  descricaoSolicitacaoExame: "",
  modeloExame: "",
  tipoExame: "",
  solicitacaoOutrosExames: [],

  //-----------------------

  condutaConclusaoEncaminhamentos: "",

  anamnese: "",
  sinaisSintomas: [],
  sinaisSintomasOutros: "",

  // novas Campos

  capacidadeVitalForcada: "",
  pressaoInspiratoria: "",
  pressaoExpiratoria: "",
  pressaoNasalInspiratoria: "",
};

export const prescricaoMedicamentos = {
  idPaciente: 0,
  idVinculo: 0,
  idMedicamento: 0,
  substancia: "",
  nomeMedicamento: "",
  apresentacao: "",
  duracaoTratamento: "",
  periodoTratamento: "dias",
  posologia: "",
  observacao: "",
  medicamentosAdicionados: [],
};

export const simOuNaoOptions = [
  { key: "Sim", value: "50" },
  { key: "Não", value: "51" },
];

export const ventilacaoNaoInvasivaDuracaoOptions = [
  { key: "Noturna. Mais de 4 horas por dia", value: "56" },
  { key: "Entre 8 e 20 horas por dia", value: "57" },
  { key: "Mais de 20 horas por dia", value: "58" },
  { key: "Menos de 4 horas por dia", value: "59" },
];

export const traqueostomiaProcedimentoOptions = [
  { key: "De urgência", value: "60" },
  { key: "Eletiva/programada", value: "61" },
];

export const tipoProcedimentoOptions = [
  { key: "Manual", value: "62" },
  { key: "Motorizada", value: "63" },
];

export const multidisciplinaridadeTipoOptions = [
  { key: "Fonoaudiologia", value: "64" },
  { key: "Fisioterapia", value: "65" },
  { key: "Psicologia", value: "66" },
  { key: "Nutrição", value: "67" },
  { key: "Enfermagem", value: "68" },
  { key: "Terapia Ocupacional", value: "69" },
  { key: "Cirurgião Dentista", value: "70" },
  { key: "Assistente Social", value: "71" },
  { key: "Pneumologista", value: "72" },
];

export const statusCognitivoOptions = [
  { key: "Normal", value: "73" },
  { key: "Disfunção comportamental (variante comportamental)", value: "74" },
  { key: "Disfunção executiva (variante cognitiva)", value: "75" },
  { key: "Demência Fronto-Temporal", value: "76" },
  { key: "Não determinado ou não definido", value: "77" },
];

export const presenteAusenteOptions = [
  { key: "Presente", value: "78" },
  { key: "Ausente", value: "79" },
];

export const reflexoNauseosoOptions = [
  { key: "Aumentado", value: "80" },
  { key: "Presente", value: "78" },
  { key: "Ausente", value: "79" },
];

export const musculaturaFacialOptions = [
  { key: "Normal", value: "73" },
  { key: "Paralisia unilateral", value: "81" },
  { key: "Paralisia bilateral", value: "82" },
  { key: "Atrofia", value: "84" },
  { key: "Fasciculações", value: "83" },
];

export const masseterOptions = [
  { key: "Normal", value: "73" },
  { key: "Paresia bilateral", value: "85" },
  { key: "Paresia à direita", value: "86" },
  { key: "Paresia à esquerda", value: "87" },
];

export const linguaMovimentacaoOptions = [
  { key: "Normal", value: "73" },
  { key: "Parética", value: "88" },
];

export const linguaAtrofiaOptions = [
  { key: "Não", value: "51" },
  { key: "Bilateral", value: "89" },
  { key: "Hemilíngua direita", value: "90" },
  { key: "Hemilíngua esquerda", value: "91" },
];

export const veloPalatinoOptions = [
  { key: "Normal", value: "73" },
  { key: "Sem movimento", value: "92" },
  { key: "Desvio para a direita", value: "93" },
  { key: "Desvio para a esquerda", value: "94" },
];

export const fasciculacoesOndeOptions = [
  { key: "MSD", value: "95" },
  { key: "MID", value: "97" },
  { key: "Língua", value: "99" },
  { key: "Face", value: "100" },
  { key: "MSE", value: "96" },
  { key: "MIE", value: "98" },
  { key: "Tórax", value: "101" },
];

export const tonusMuscularOptions = [
  { key: "Normal", value: "73" },
  { key: "Hipotônico", value: "102" },
  { key: "Hiperônico", value: "103" },
];

export const reflexoOptions = [
  { key: "Em flexão", value: "109" },
  { key: "Em extensão", value: "110" },
  { key: "Sem resposta", value: "111" },
];

export const avaliacaoSegmentarOptions = [
  { key: "Normal", value: "73" },
  { key: "Diminuida", value: "112" },
  { key: "Ausente", value: "89" },
];

export const examesPredefinidosOptions = [
  { key: "Adicionar todos os exames", value: "2" },
  { key: "Exames complementares (PDCT)", value: "3" },
];

export const disfuncaoAutonomicaOptions = [
  { key: "Cardíaca (arritmia, taquicardia, bradicardia)", value: "113" },
  {
    key: "Pressão sanguínea (flutuações, hipertensão, hipotensão)",
    value: "114",
  },
  { key: "Gastroentérica constipação, íleo", value: "115" },
  { key: "Disfunção vesical", value: "116" },
  { key: "Disfunção pupilar", value: "117" },
  { key: "Outra", value: "118" },
];

export const diagnosticoEhELAOptions = [
  { key: "Sim", value: "50" },
  { key: "Não", value: "51" },
  { key: "Em investigação", value: "119" },
];

export const classificacaoKingsCollegeOptions = [
  { key: "Estágio 1", value: "120" },
  { key: "Estágio 2", value: "121" },
  { key: "Estágio 3", value: "122" },
  { key: "Estágio 4", value: "123" },
  { key: "Estágio 5", value: "124" },
];

export const causaOptions = [
  { key: "Esporádica", value: "125" },
  { key: "Familiar", value: "126" },
];

export const localDeInicioOptions = [
  { key: "Espinhal", value: "127" },
  { key: "Bulbar", value: "128" },
];

export const fenotipoDeInicioOptions = [
  { key: "Bulbar", value: "128" },
  { key: "Clássica", value: "129" },
  { key: "Síndrome flail-arm (doença de Vulpian-Bernhardt)", value: "130" },
  { key: "Síndrome flail-leg (forma pseudopolineurítica)", value: "131" },
  { key: "Atrofia Muscular Progressiva", value: "132" },
  { key: "Variante respiratória da ELA", value: "133" },
  { key: "Variante de predomínio do Neurônio Motor Superior", value: "134" },
  { key: "Esclerose Lateral Primária", value: "135" },
  { key: "ELA plus/extrapiramidal", value: "136" },
  { key: "Síndrome de Fazio-Londe", value: "137" },
  { key: "Síndrome de Brown-Vialetto-Van Laere (SBVVL)", value: "138" },
  {
    key: "Doença neuromotora de Madras Síndrome de O'Sullivan-McLeod",
    value: "139",
  },
  { key: "Síndrome FEWDON-MND", value: "140" },
];

export const examesPredefinidosList = [
  { key: "Hemograma completo", value: "1" },
  { key: "VSH", value: "2" },
  { key: "PCR", value: "3" },
  { key: "TGO", value: "4" },
  { key: "TGP", value: "5" },
  { key: "GGT", value: "6" },
  { key: "HTLV 1 e 2", value: "7" },
  { key: "FAN", value: "8" },
  { key: "Fator reumatóide", value: "9" },
  { key: "ECA", value: "10" },
  { key: "Lactase", value: "11" },
  { key: "Anticorpo anti-GM1", value: "12" },
  { key: "Billirubinas total direta e indireta", value: "13" },
  { key: "LDH", value: "14" },
  { key: "Vitamina B12", value: "15" },
  { key: "Ácido fólico", value: "16" },
  { key: "Glicemia", value: "17" },
  { key: "CPK", value: "18" },
  { key: "Anticorpo anti-Hu", value: "19" },
  { key: "Anticorpo anti-MAG", value: "20" },
  { key: "Anticorpo anti-DNA", value: "21" },
  { key: "Anticorpo anti-AChR", value: "22" },
  { key: "Anticorpo anti-MUSK", value: "23" },
  { key: "Sorologia para borrelia", value: "24" },
  { key: "Uréia", value: "25" },
  { key: "Creatina", value: "26" },
  { key: "Sódio", value: "27" },
  { key: "Fósforo", value: "28" },
  { key: "TSH", value: "29" },
  { key: "T4 Livre", value: "30" },
  { key: "Ácido úrico", value: "31" },
  { key: "Albumina", value: "32" },
  { key: "Colesterol HDL", value: "33" },
  { key: "Colesterol LDL", value: "34" },
  { key: "Colesterol Total", value: "35" },
  { key: "Imunoeletroforese", value: "36" },
  { key: "Anti-HIV", value: "37" },
  { key: "Anti-HCV", value: "38" },
  { key: "HbsAg", value: "39" },
  { key: "VDRL", value: "40" },
  { key: "Ferritina", value: "41" },
  { key: "Fosfatase Alcalina", value: "42" },
  { key: "Glicose", value: "43" },
  { key: "Triglicerídeos", value: "44" },
  { key: "Creatina Quinase", value: "45" },
  { key: "Creatinina", value: "46" },
];

export const substanciaOptions = [
  { key: "Substancia 1", value: "127" },
  { key: "Substancia 2", value: "128" },
  { key: "Substancia 3", value: "129" },
  { key: "Substancia 4", value: "130" },
];

export const nomeMedicamentoOptions = [
  { key: "Medicamento 1", value: "127" },
  { key: "Medicamento 2", value: "128" },
  { key: "Medicamento 3", value: "129" },
  { key: "Medicamento 4", value: "130" },
];

export const apresentacaoOptions = [
  { key: "Apresentação 1", value: "127" },
  { key: "Apresentação 2", value: "128" },
  { key: "Apresentação 3", value: "129" },
  { key: "Apresentação 4", value: "130" },
];

export const periodoTratamentoOptions = [
  { key: "dia(s)", value: "dias" },
  { key: "mese(s)", value: "meses" },
  { key: "Contínuo", value: "continuo" },
];

export const sinaisSintomasList = [
  { key: "Atividade física intensa", value: "11" },
  { key: "Perda de sensibilidade", value: "12" },
  { key: "Dificuldades na escrita", value: "13" },
  { key: "Perda de peso", value: "14" },
  { key: "Sono (sonolência diurna)", value: "15" },
  { key: "Cãibras", value: "16" },
  { key: "Disfonia", value: "17" },
  { key: "Edemas", value: "18" },
  { key: "Atrofia", value: "19" },
  { key: "Dor", value: "20" },
  { key: "Sialorréia", value: "21" },
  { key: "Ortopnéia", value: "22" },
  { key: "Dispneia", value: "23" },
  { key: "Cefaléia matinal", value: "24" },
  { key: "Humor", value: "25" },
  { key: "Força para tossir", value: "26" },
  { key: "Choro ou riso incontrolado", value: "27" },
  { key: "Disartria", value: "28" },
  { key: "Alterações na marcha", value: "29" },
  { key: "Disfagia", value: "30" },
  { key: "Alteração dos esfincteres urinário e fecal", value: "31" },
  { key: "Fraqueza", value: "32" },
  { key: "Fasciculações", value: "33" },
  { key: "Outros", value: "34" },
];
